//React
import React from "react";
//Routing
import { Navigate, Routes, Route } from "react-router-dom";
//Components
import LoginPage from "../../Features/Authentication/LoginPage";
import PrivateRoute from "./PrivateRoute";
import PermissionRedirection, { RequireGroups } from "./PermissionRedirection";
import { RESIDENTS_ANALYTICS_GROUPS, USER_MANAGEMENT_GROUPS } from "../permissions/checkPermissions";
import UsersManagement from "../../Features/Userport/UsersManagement"
import DashboardPage from "../../Features/Dashboard/DashboardPage";
import ComingSoon from "../../Features/Dashboard/ComingSoon";
import Notifications from "../../Global/notifications/Notifications";
import ClientAppsPage from "../../Features/Dashboard/ClientAppsPage";
import Profile from "../../Features/Userport/Profile";
//Components/Layout
import AppLayout from "../navbar/AppLayout";
import ResidentsAnalytics from "../../Features/Dashboard/Analytics/ResidentsAnalytics";
import { RedirectToResidents } from "../../Features/Userport/RedirectToResidents";
export default function MainRouter() {

  return (
    <>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route element={<PermissionRedirection />}>
            {/* Shared chrome lives in one layout route rather than being
                composed per-route, so the sidebar offset has a single owner. */}
            <Route element={<AppLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route element={<RequireGroups groups={USER_MANAGEMENT_GROUPS} />}>
                <Route path="/userport" element={<UsersManagement />} />
              </Route>
              <Route path="/clientapps" element={<ClientAppsPage />} />
              <Route element={<RequireGroups groups={RESIDENTS_ANALYTICS_GROUPS} />}>
                <Route path="/residents-analytics" element={<ResidentsAnalytics />} />
              </Route>
              {/* Both navbars have always linked here, but no route matched it,
                  so Profile rendered a blank page. */}
              <Route path="/profile" element={<Profile />} />
            </Route>
            <Route path="/comingsoon" element={<ComingSoon />} />
          </Route>
        </Route>
        <Route path="/login" element={<LoginPage />}></Route>

        {/* Public deep link. This used to live in a second <Routes> rendered
            alongside this one, which meant both trees matched every URL
            independently — harmless only because neither had a catch-all.
            Folded in here so the catch-all below cannot hijack it. */}
        <Route path="/dbms/ims/:serial_number/:sim_number" element={<RedirectToResidents />} />

        {/* There was no catch-all, so any unmatched path rendered nothing at
            all rather than going somewhere useful. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Notifications />
    </>
  );
}
